<template>
  <nav class="mobile_nav">
    <ul>
      <li><a href="#">How it works</a></li>
      <li><a href="">Our Services</a></li>
      <li><a href="">About Us</a></li>
    </ul>
    <div class="mobile_nav_btn">
      <a href="">Download App</a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MobileNav",
};
</script>

<style lang="scss" src="../styles/header.scss"></style>
